import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "rmj_session_token";

export const setAuthToken = (token) => {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
};

export const getAuthToken = () => localStorage.getItem(TOKEN_KEY);

const api = axios.create({
  baseURL: API,
  // Bearer tokens are sent via Authorization header (see interceptor below) so
  // we DO NOT need cross-origin cookies. Setting withCredentials: true forces
  // the browser to require an explicit non-wildcard CORS origin, which breaks
  // the linked production domain (CORS_ORIGINS="*" + credentials is invalid
  // per spec → request is blocked with a silent "Network Error").
  withCredentials: false,
});

// Inject Authorization: Bearer <token> on every request when available.
// This is the primary auth channel and works regardless of cross-origin
// cookie policies / proxy stripping.
api.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
